// extracted by mini-css-extract-plugin
module.exports = {"googleButton":"GoogleLoginButton_googleButton__ugVTB","googleIcon":"GoogleLoginButton_googleIcon__D7QdY"};